import { PROFILE_SHORTS_FEED_URL } from "./endpoints";
import type { ShortsFeedItemData } from "@components/organisms/ShortsFeed/ShortsFeed.types";

export const isValidShortsFeedItem = (
  item: Partial<ShortsFeedItemData>
): item is ShortsFeedItemData =>
  Boolean(
    item?.title?.trim() &&
      item?.description?.trim() &&
      item?.sourceUrl?.trim() &&
      item?.thumbnail
  );

export const normalizeShortsFeedItems = (
  items: unknown
): ShortsFeedItemData[] =>
  Array.isArray(items) ? items.filter(isValidShortsFeedItem) : [];

export const myProfileShortsFeed = async (
  page: number = 1,
  size: number = 10
) => {
  try {
    const apiURL = `${PROFILE_SHORTS_FEED_URL}?page=${page}&size=${size}`;
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    try {
      const response = await fetch(apiURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        signal: controller.signal,
      });

      const data = await response.json();
      return normalizeShortsFeedItems(data?.response);
    } finally {
      clearTimeout(timeoutId);
    }
  } catch (error: any) {
    console.error("Error fetching Shorts Feed :", error.message);
    return null;
  }
};
